import React, {useState} from 'react';
import {createPortal} from 'react-dom';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import MobileHeader from './MobileHeader';
import Modal from '../../../../../incase-domain/components/modals/directory/Modal';
import {useLogout} from '../queries';
import useNotification from '../../../../../service/hooks/useNotification';
import {NOTIFICATIONS_HAMBURGER_SIZE_DEFAULT_VALUES} from '../../../../../constants';
import {NotificationStatus} from '../../../../../incase-domain/notification';
import LanguageSelector from '../../../../../incase-domain/widgets/languageSelector/LanguageSelector';
import ConfirmModal from '../../../../../incase-domain/components/modals/confirmModal/ConfirmModal';

function MobileHeaderIcons(): JSX.Element {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const {notifications} = useNotification(NOTIFICATIONS_HAMBURGER_SIZE_DEFAULT_VALUES, [NotificationStatus.ACTIVE]);
    const hasUnreadNotifications = notifications.data && notifications.data.numberOfUnseen > 0;

    const [loginModal, setLoginModal] = useState<boolean>(false);
    const [languageModal, setLanguageModal] = useState<boolean>(false);

    const logout = useLogout();
    const onLogoutConfirm = (): void => {
        logout();
    };

    return (
        <>
            <MobileHeader
                menuItems={[
                    {
                        name: t('header.languages.locale'),
                        items: [
                            {
                                icon: 'ph:globe',
                                label: t('header.languages.languages'),
                                callback: () => {
                                    setLanguageModal(true);
                                },
                                disabled: false,
                            },
                        ],
                    },
                    {
                        name: t('header.messages.messages'),
                        items: [
                            {
                                label: t('header.messages.notifications'),
                                icon: 'ph:bell',
                                callback: () => {
                                    if (hasUnreadNotifications) {
                                        navigate('/notifications/unread');
                                    } else {
                                        navigate('/notifications');
                                    }
                                },
                            },
                            {
                                label: t('header.messages.messages'),
                                icon: 'ph:envelope-simple',
                                callback: () => navigate('/messages'),
                            },
                        ],
                    },
                    {
                        name: t('header.profile.profile'),
                        items: [
                            {
                                label: t('header.profile.settings'),
                                icon: 'ph:gear-fill',
                                callback: () => navigate('/settings'),
                            },
                            {
                                label: t('header.profile.logOut'),
                                icon: 'ph:sign-in-fill',
                                callback: () => setLoginModal(true),
                            },
                        ],
                    },
                ]}
                showProfile
            />
            {createPortal(
                <ConfirmModal
                    message={t('sidebar.logoutText')}
                    isOpen={loginModal}
                    onCancel={() => setLoginModal(false)}
                    onConfirm={onLogoutConfirm}
                    confirmText={t('sidebar.logoutConfirm')}
                    cancelText={t('sidebar.cancel')}
                    showCancel
                    showConfirm
                />,
                document.body
            )}
            <Modal
                header={t('header.languages.languageModalTitle')}
                isOpen={languageModal}
                onCancel={() => setLanguageModal(false)}
                size="sm"
            >
                <LanguageSelector />
            </Modal>
        </>
    );
}

export default MobileHeaderIcons;
